import * as swcHelpers from '@swc/helpers';
import React__default, { useRef, useCallback, useEffect } from 'react';
import { useWasSeenByUser } from '@grandvisionhq/analytics';
import { pushProductClick, pushProductImpressions } from '../utils/data-layer.js';
import { ProductRecommendation } from './ProductRecommendation.js';

const ProductRecommendationContainer = (props)=>{
    const { recommendation , position , enableAddToCartCta  } = props;
    const clickRef = useRef(false);
    const { ref , wasSeen  } = useWasSeenByUser();
    const handleRecommendationClick = useCallback(()=>{
        if (!clickRef.current) {
            pushProductClick(recommendation, position);
            clickRef.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(()=>{
        if (wasSeen) {
            pushProductImpressions(recommendation, position);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        wasSeen
    ]);
    return /*#__PURE__*/ React__default.createElement(ProductRecommendation, swcHelpers.extends({
        ref: ref
    }, props, {
        onClick: handleRecommendationClick,
        enableAddToCartCta: enableAddToCartCta
    }));
};

export { ProductRecommendationContainer };
//# sourceMappingURL=ProductRecommendationContainer.js.map
